import { datadogRum } from '@datadog/browser-rum';
import axios, { AxiosResponse } from 'axios';
import { useRouter } from 'next/router';

import { getAxiosError } from 'utils/getAxiosError';
import { sendToErrorTracking } from 'utils/sendToErrorTracking';

export interface CloudinaryCredentialsResponse {
  cloudName: string;
  apiKey: string;
  apiSecret: string;
  presetName: string;
}

export const useUploadAsset = () => {
  const router = useRouter();

  // @param {string[]} file This is a list of base64, we expect this to
  // be used on onSubmit method
  const upload = async (files: string[]) => {
    try {
      const response: AxiosResponse<string[]> = await axios.post(
        '/api/cloudinary',
        {
          files,
        },
      );

      datadogRum.addAction('useUploadAsset', {
        useUploadAsset: files,
      });

      return response.data;
    } catch (error) {
      sendToErrorTracking({ error, where: 'useUpload', context: files });

      if (getAxiosError(error).response?.status === 500) router.push('/500');
    }
  };

  return { upload };
};
